"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Spinner = require("@styled-icons/icomoon/Spinner2");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    animation: .7s linear 0s normal none infinite running rotate;\n    width: 50px;\n    svg {\n        fill: #f54d2e;\n    }\n    @keyframes rotate {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents["default"].div(_templateObject());

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner2, {
    size: 50,
    color: "#29d"
  }));
};

exports["default"] = _default;